import xss from 'xss'

import { Text } from '@wartek-id/text-v1'

import { nl2br, stripHTMLTags } from 'utils/text'

import type { FC } from 'react'

type BlockQuestionAnswerPreviewProps = {
  index: number
  question: string
  answer: string
}

const BlockQuestionAnswerPreview: FC<BlockQuestionAnswerPreviewProps> = ({
  index,
  question,
  answer,
}) => {
  return (
    <div className="space-y-2">
      {/* <Text variant="action">{question}</Text> */}
      <div className="flex items-center gap-x-3">
        <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-blue-70">
          <Text color="inverse" variant="body-sm-bold">
            {index + 1}
          </Text>
        </div>
        <Text variant="action">{question}</Text>
      </div>
      <div className="pl-9">
        <Text
          variant="body"
          color="subdued"
          aria-label={`Answer for ${question}`}
          dangerouslySetInnerHTML={{
            __html: nl2br(stripHTMLTags(xss(answer))),
          }}
        />
      </div>
    </div>
  )
}

export default BlockQuestionAnswerPreview
